import React, { useState, useEffect, useRef } from "react";

const CustomSelect = (props) => {
  const { id, items, className, handleChange, readOnly, placeholder = '' } = props;

  const [dropVisible, _setDropState] = useState("");
  const dropVisibleRef = useRef(dropVisible);
  const isMounted = useRef(false);
  var currentPlaceholder = placeholder !== '' ? placeholder : "Seleccione..."
  const [selectedValue, setSelectedValue] = useState(currentPlaceholder);

  useEffect(() => {
    if (props.value !== undefined) {
      if (props.value == "" && selectedValue !== currentPlaceholder) {
        setSelectedValue(currentPlaceholder);
      } else {
        items.map((item) => {
          if (props.value == item[props.valueAttr]) {
            setSelectedValue(item.name);
          }
        });
      }
    }

    document.addEventListener("click", closeSelect, false);

    return () => {
      document.removeEventListener("click", closeSelect, false);
    }
  }, [props.value]);

  useEffect(() => {
    if(!isMounted.current) return;
    setSelectedValue(placeholder)
  }, [placeholder]);

  useEffect(() => {
    isMounted.current = true;
  }, [])

  const setDropState = data => {
    dropVisibleRef.current = data;
    _setDropState(data);
  }

  const closeSelect = (event) => {
    event.stopPropagation();
    if( event.target.id !== props.id && dropVisibleRef.current != "" ) {
      clickHandler();
    }
  }

  const clickHandler = () => {
    let visible = dropVisibleRef.current == "" ? "show-select" : "";
    setDropState(visible);
  };

  const selectItem = (item) => {
    const { name, valueAttr } = props;
    const target = {};
    setSelectedValue(item.name);
    if (undefined !== name) {
      target.name = name;
    }
    if (undefined !== valueAttr) {
      target.value = item[valueAttr];
    }
    handleChange({ ...item, target: target });
    clickHandler();
  };

  return (
    <div className={`custom-content-select ${className}`}>
      <div id={id}
        className={`select-selected ${readOnly === true ? "readOnly" : ""}`}
        onClick={clickHandler}
      >
        {selectedValue}
      </div>
      {readOnly !== true && (
        <div className={`select-items ${dropVisible}`}>
          {items.length > 0 &&
            items.map((item, key) => (
              <div key={`item-${key}`} onClick={() => selectItem(item)}>
                {item.name}
              </div>
            ))}
        </div>
      )}
    </div>
  );
};

export default CustomSelect;
